module.exports = __webpack_public_path__ + "img/s8-qb1.7a95ba3d.png";